<script setup>
import { ref } from 'vue'

const props = defineProps({
  trueValue: {
    type: [Boolean, Number, String],
    default: true,
  },
  falseValue: {
    type: [Boolean, Number, String],
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'medium',
  },
})
const emits = defineEmits(['update:modelValue'])
const modalValue = defineModel('modelValue', {
  type: [Boolean, Number, String],
  default: false,
})
function onChecked(value) {
  emits('update:modelValue', value ? props.trueValue : props.falseValue)
}
const id = ref(Math.random().toString(36).slice(2))
</script>

<template>
  <label :id="id" class="inline-flex items-center h-4 cursor-pointer select-none text-textPrimary group" :class="{ '!cursor-not-allowed !text-textDisabled': disabled, 'text-xs !h-3': size === 'small' }">
    <input
      :id="id"
      type="checkbox"
      class="hidden peer"
      :checked="modelValue"
      :disabled="disabled"
      @change="onChecked($event.target.checked)"
    >
    <i
      class="flex items-center justify-center flex-shrink-0 w-4 h-4 me-2 transition border-[1.5px] peer-checked:border-0 border-border rounded text-[0px] " :class="{
        'peer-checked:bg-btnPrimary group-hover:border-btnPrimary': !disabled,
        'bg-btnPrimary opacity-40': disabled && modelValue,
        'bg-inputDefault': disabled && !modelValue,
        '!h-3 !w-3': size === 'small',
      }"
    >
      <svg width="10" height="8" viewBox="0 0 10 8" class="text-textOnBtn" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{ 'opacity-0': !modalValue, 'w-[6.5px] h-[5.75px]': size === 'small' }">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.94079 0.372335C9.3795 0.707821 9.46318 1.33543 9.1277 1.77414L4.79436 7.44081C4.60604 7.68709 4.31413 7.83208 4.0041 7.83335C3.69408 7.83462 3.40099 7.69202 3.21065 7.4473L0.87732 4.4473C0.53825 4.01135 0.616784 3.38308 1.05273 3.04401C1.48868 2.70494 2.11695 2.78347 2.45602 3.21942L3.9933 5.19591L7.53898 0.559243C7.87447 0.120531 8.50208 0.0368498 8.94079 0.372335Z" fill="currentColor" />
      </svg>

    </i>
    <slot />
  </label>
</template>
